import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import moment from "moment";
import { bindActionCreators } from "redux";

import { setIsShown } from "../components/HeaderResponsive/actions";
import { get } from "../../common/offer/actions";
import { setLocation } from "../../common/app/actions";
import Offers from "./Offers";

moment.locale("pl");

class Single extends React.Component {
  componentDidMount() {
    const { setIsShown } = this.props;
    setIsShown(false);
    window.scrollTo(0, 0);
  }

  render() {
    const { params: { slug } } = this.props;

    const seoTitle = "agency title";
    const seoDescription = "agency description";

    return (
      <div>
        <Helmet
          title={seoTitle}
          description={seoDescription}
          meta={[
            { name: "description", content: seoDescription },
            { property: "og:type", content: "website" },
            { property: "og:title", content: seoTitle },
            { property: "og:description", content: seoDescription },
            {
              property: "og:image",
              content: "https://opiekujsie.pl/static/home-background.jpg"
            }
          ]}
        />

        <Offers showPagination agencyUID={slug} />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ setIsShown }, dispatch);
};

export default connect(() => ({}), mapDispatchToProps)(Single);



/** WEBPACK FOOTER **
 ** ./src/browser/offers/AgencyOffers.js
 **/